import React from "react";
import { Box, keyframes } from "@mui/material";

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const shimmerBase = {
  background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
  backgroundSize: "800px 100%",
  animation: `${shimmer} 1.5s infinite ease-in-out`,
  borderRadius: "4px",
};

const LocationSearchSkeleton = ({ height = "56px" }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          ...shimmerBase,
          width: "100%",
          height,
          borderRadius: "8px",
        }}
      />
    </Box>
  );
};

export default LocationSearchSkeleton;
